import { useAjax, useDownloadBrowser, useMzMutation } from "@bsm/component";

export const useExportDayOffMutation = () => {
    const ajax = useAjax();
    const download = useDownloadBrowser()

    return useMzMutation(async (id: string) =>
        ajax.send({
            type: "GET",
            content_type: "application/json",
            url: `project/dayoff/${id}/export/pdf`,
            data_type: 'application/octet-stream',
            data: {},
        }),
        {
            onSuccess: (data) => {
                let filename = 'dayoff-details.pdf';
                const disposition = data.xhr?.getResponseHeader
                    ? data.xhr.getResponseHeader('Content-Disposition')
                    : data.response?.headers?.get('Content-Disposition');
                if (disposition && disposition.includes('filename=')) {
                    filename = disposition.split('filename=')[1].replace(/"/g, '');
                }
                const blob = new Blob([data.response]);

                download(blob, filename);
            }
        }
    );
};
